
export default {
    name: 'SocialMediaList'

    props: ['id']

    data: ->
        documentId: ''
        fields: @defaultFields()

    methods:
        defaultFields: ->
            social_media_fields: []

        getIcon: (field) ->
            switch field.network
                when 'Facebook' then 'facebook'
                when 'Google+' then 'google-plus'
                when 'Instagram' then 'instagram'
                when 'Linkedin' then 'linkedin'
                when 'Tumblr' then 'tumblr'
                when 'Twitter' then 'twitter'
                when 'Youtube' then 'youtube'
                when 'XING' then 'xing'

        setContent: (document) ->
            @documentId = document.id
            fields =
                social_media_fields: document.data.social_media_fields
            $.extend @fields, fields

        getContent: (id) ->
            @$prismic.client.query(@$prismic.Predicates.at 'document.id', id).then (response) =>
                if response.results then @setContent response.results[0]

    created: ->
        @getContent @id

}
